import { config } from "../../../config"
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { getLogo, getAuthBackgrpund, getShortName } from "../../../layouts/layout";

import {
  InputGroup,
  // InputGroupAddon,
  InputGroupText,
  Input,
  Form,
  Row,
  Col,
  Label,
  Button,
} from "reactstrap";

import { deviceApi } from "../../identity/reducers/identitySlice"
import validators from "./LoginValidators";

// import img1 from '../../../assets/images/logo-icon-tcs.png';
// import img2 from "../../../assets/images/big/auth-bg.jpg";
import Footer from "../../../layouts/layout-components/footer/Footer";


const sidebarBackground = {
  backgroundImage: "url(" + getAuthBackgrpund() + ")",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",
};

const Login = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const status = useSelector((state) => state.identityReducer.status);
  const error = useSelector((state) => state.identityReducer.error);
  const errorCode = useSelector((state) => state.identityReducer.errorCode);
  const userStatus = useSelector((state) => state.userReducer.status);
  
  const dispatch = useDispatch();

  const onInputChange = (e) => {
    formValidators([e.target.name], e.target.value);
  };

  const formValidators = (fieldName, value) => {
    validators[fieldName].errors = [];
    validators[fieldName].state = value;
    validators[fieldName].valid = true;
    validators[fieldName].rules.forEach((rule) => {
      if (rule.test instanceof RegExp) {
        if (!rule.test.test(value)) {
          validators[fieldName].errors.push(rule.message);
          validators[fieldName].valid = false;
        }
      } else if (typeof rule.test === "function") {
        if (!rule.test(value)) {
          validators[fieldName].errors.push(rule.message);
          validators[fieldName].valid = false;
        }
      }
    });
  };

  const validForm = () => {
    let status = true;
    Object.keys(validators).forEach((field) => {
      if (field === "email" || field === "password") {
        if (!validators[field].valid) {
          status = false;
        }
      }
    });
    return status;
  };

  const showErrors = (fieldName) => {
    const validator = validators[fieldName];
    const result = "";
    if (validator && !validator.valid) {
      const errors = validator.errors.map((info, index) => {
        return (
          <span className="error" key={index}>
            * {info}
            <br />
          </span>
        );
      });
      return <div className="error mb-2">{errors}</div>;
    }
    return result;
  };

  const doLogin = (event) => {
    dispatch( deviceApi.login({username: email, password: password}) );
    // history.push('/analytics'); //ERRORE fa il redirect prima della risposta di login
    event.preventDefault();
  };

  return (
    <div className={config.instance.id} id={config.instance.id}>
      <div
        className="auth-wrapper  align-items-center d-flex"
        style={sidebarBackground}
      >
        {/*--------------------------------------------------------------------------------*/}
        {/*Login Cards*/}
        {/*--------------------------------------------------------------------------------*/}
        <div className="container">
          <div>
            <Row className="no-gutters justify-content-center">
              <Col md="6" lg="4" className="bg-white">
                <div className="p-4">
                  
                  <h3 className="font-medium mb-3"><span className="db"><img src={getLogo()} alt="logo" width="40" height="40" /></span> Accedi a {getShortName()}</h3>
                  <Form className="mt-3" id="loginform" action="">
                    { (status === 'recovery/succeeded' || status === 'recovery/rejected') ? (
                      <Row className="mb-3">
                        <Col xs="12">
                          <span className="success">
                            You will shortly receive a new password to your email address 
                            <br />
                          </span>
                        </Col>
                      </Row>
                    ) : null }

                    { (userStatus === 'user/succeeded') ? (
                      <Row className="mb-3">
                        <Col xs="12">
                          <span className="success">
                            Account created successfully, log in to use the app 
                            <br />
                          </span>
                        </Col>
                      </Row>
                    ) : null }

                    <Label for="email" className="font-medium">
                      Email
                    </Label>
                    <InputGroup className="mb-2" size="lg">
                      {/* <InputGroupAddon addonType="prepend"> */}
                        <InputGroupText>
                          <i className="ti-user"></i>
                        </InputGroupText>
                      {/* </InputGroupAddon> */}
                      <Input
                        type="email"
                        id="email"
                        name="email"
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                          onInputChange(e);
                        }}
                        placeholder="Email"
                      />
                    </InputGroup>
                    {showErrors("email")}
                    <Label for="password" className="mt-3 font-medium">
                      Password
                    </Label>
                    <InputGroup className="mb-3" size="lg">
                      {/* <InputGroupAddon addonType="prepend"> */}
                        <InputGroupText>
                          <i className="ti-pencil"></i>
                        </InputGroupText>
                      {/* </InputGroupAddon> */}
                      <Input
                        type="password"
                        id="password"
                        name="password"
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                          onInputChange(e);
                        }}
                        placeholder="Password"
                      />
                    </InputGroup>

                    {error ? (
                      <Row className="mb-3">
                        <Col xs="12">
                          <span className="error">
                            {error}
                            <br />
                          </span>
                        </Col>
                      </Row>
                    ) : showErrors("password") }

                    

                    {/* <div className="d-flex no-block align-items-center mb-4 mt-4">
                      <CustomInput
                        type="checkbox"
                        id="exampleCustomCheckbox"
                        label="Remember Me"
                      />
                    </div> */}
                    
                    <Row className="mb-3">
                      <Col xs="12">
                        <Button
                          color="primary"
                          onClick={(event) => doLogin(event)}
                          className={`${validForm() ? "" : "disabled"}`}
                          size="lg"
                          type="submit"
                          block
                        >
                          Log In
                        </Button>
                      </Col>
                    </Row>
                    {/* <div className="text-center">
                      Don&apos;t have an account?{" "}
                      <a
                        href="/register"
                        className="text-info ml-1"
                      >
                        <b>Sign Up</b>
                      </a>
                    </div> */}
                    {errorCode === config.restError.Forbidden ? <div className="text-center">
                      Hai dimenticato la password?
                      <a
                        href="/recovery"
                        className="text-warning ml-1"
                      >
                        <b>Recuperala</b>
                      </a>
                    </div> : null}
                    {errorCode === config.restError.PreconditionFailed ? <div className="text-center">
                      Do you want a new code?
                      <a
                        href="/new-confirmation"
                        className="text-warning ml-1"
                      >
                        <b>New code</b>
                      </a>
                    </div> : null}
                  </Form>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <div style={{position: 'absolute', bottom: 0, width: '100%'}}>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Login;
